import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
	selector: 'app-titled-add-toolbar',
	templateUrl: './titled-add-toolbar.component.html',
	styleUrls: ['./titled-add-toolbar.component.scss']
})
export class TitledAddToolbarComponent {

	@Input()
	title = '' as string;

	@Input()
	isButton = false;

	@Input()
	color = 'primary' as string;

	@Input()
	size = 'large' as string;

	@Output()
	clickedAdd = new EventEmitter<boolean>();

	@Output()
	clickedPrimary = new EventEmitter<boolean>();

	onClick() {
		this.clickedAdd.emit(true);
	}

	onClickPrimary() {
		this.clickedPrimary.emit(true);
	}

}
